import { render, staticRenderFns } from "./Management.html?vue&type=template&id=9a63c916&external"
import script from "./Management.ts?vue&type=script&lang=ts&external"
export * from "./Management.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports